/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { Link, useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";
import {
  useUserRegister,
  useUserSignIn,
} from "../../../../../../api/mutations/auth.mutation";
import { signInSuccess } from "../../../../../../store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../../store/hook";
import * as RoleSelector from "src/store/role/selector";
import PhoneInputWithCountrySelect from "react-phone-number-input";

function SocialLinksForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    email: yup.string().required("Please enter your email"),
    password: yup.string().required("Please enter your password"),
    rememberMe: yup.bool(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useAppSelector(RoleSelector.selectUserRole);

  const userLoginMutation = useUserSignIn({
    onSuccess: (data) => {
      dispatch(signInSuccess("token"));
      navigate("/u");
    },
    onError: (error) => {
      if (error.message) {
      }
    },
    successMessage: "Login Successful!",
  });

  const onSignIn = (data) => {};

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSignIn}
      initialValues={{
        email: "",
        password: "",
        rememberMe: false,
      }}
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <Form noValidate onSubmit={handleSubmit} className="">
          <Row className="mb-2">
            <h3 className="mb-3 fs-4">Social Links</h3>
            <Form.Group
              as={Col}
              controlId="validationFormikFacebook"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Facebook</Form.Label>
              <Form.Control
                type="facebook"
                placeholder="Your Facebook Link"
                name="facebook"
                value={values.facebook}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikLinkedIn"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">LinkedIn</Form.Label>
              <Form.Control
                type="linkedin"
                placeholder="Your LinkedIn"
                name="linkedin"
                value={values.linkedin}
                onChange={handleChange}
                className="form-control mb-0"
              />
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikWebsite"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Website</Form.Label>
              <Form.Control
                type="website"
                placeholder="Your Website"
                name="website"
                value={values.website}
                onChange={handleChange}
                isInvalid={!!errors.website}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.website}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationInstagram"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Instagram</Form.Label>
              <Form.Control
                type="instagram"
                placeholder="Your Instagram"
                name="instagram"
                value={values.instagram}
                onChange={handleChange}
                isInvalid={!!errors.instagram}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.instagram}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationYoutube"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">YouTube</Form.Label>
              <Form.Control
                type="youtube"
                placeholder="Your YouTube"
                name="youtube"
                value={values.youtube}
                onChange={handleChange}
                isInvalid={!!errors.youtube}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.youtube}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success-subtle"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Save & Update
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default SocialLinksForm;
